
<div *ngIf="view == 0">
<div class="card shadow-sm">
  <div class="card-header" style="background-color: #2c3e50; color: white; padding: 6px 10px; border-radius: 8px 8px 0 0;">
    <h5 class="mb-0 font-weight-bold" style="color: white;">Notizen</h5>
  </div>
  <div class="card-body" style="padding: 10px;">
    <input style="margin-bottom: 10px;" [(ngModel)]="description" placeholder="Notiz" class="form-control"/>
    <button class="btn form-control" (click)="storeNote()" style="background-color: #2c3e50; color: #fff; border-color: #2c3e50;">speichern</button>
  </div>
</div>
<table class="table table-striped table-hover" style="border-top: 0px !important; margin-top: 0px;">
  <tbody>
  <tr class="cursor-pointer" style="width: 100% !important" *ngFor="let note of noteList || []">
    <td style="padding: 5px; width: 40px;">
      <div class="circle">
        <span class="font-bold text-white">{{note.user?.short}}</span>
      </div>
      <!--div class="avatar">
        <img class="rounded-circle" src="../../../../assets/images/portrait/small/silke.jpg" alt="Generic placeholder image"/>
      </div-->
    </td>
    <td style=" width: 160px;"> {{note.user?.name}}</td>
    <td style=" width: 200px;">{{note.created_at | date: 'dd.MM.yyyy, HH:mm'}}Uhr</td>
    <td [ngClass]="{'text-muted text-decoration-line-through': isNoteDeleted(note)}">{{note.description}}</td>
    <td style="width: 50px;">
      <button *ngIf="!isNoteDeleted(note)" 
              class="btn btn-sm" 
              [ngClass]="isNoteWithin10Minutes(note) ? 'btn-danger' : 'btn-outline-danger'"
              (click)="deleteNote(note.id, note)" 
              [title]="isNoteWithin10Minutes(note) ? 'Endgültig löschen (innerhalb 10 Min)' : 'Als gelöscht markieren'">
        <i class="fa fa-trash"></i>
      </button>
      <small *ngIf="isNoteDeleted(note)" class="text-muted">Gelöscht</small>
    </td>
  </tr>
  </tbody>
</table>
</div>

<div *ngIf="view==1">
<div class="card shadow-sm">
  <div class="card-header" style="background-color: #2c3e50; color: white; padding: 6px 10px; border-radius: 8px 8px 0 0;">
    <h5 class="mb-0 font-weight-bold" style="color: white;">Notizen</h5>
  </div>
  <div class="card-body" style="padding: 10px;">
    <input style="border: 3px solid #666 !important; margin-bottom: 10px;"  [(ngModel)]="description" placeholder="Notiz" class="form-control"/>
    <button class="btn form-control" (click)="storeNote()" style="background-color: #2c3e50; color: #fff; border-color: #2c3e50;">speichern</button>
  </div>
</div>
  <table class="w-full" style="border-top: 0px !important; margin-top: 0px;">
    <tbody  class="cursor-pointer p-0.5" style="border-bottom: 1px solid #ddd; width: 100% !important" *ngFor="let note of noteList || []">
    
    <tr style="padding-left: 5px !important;">
      <td>
        <div class="d-flex justify-content-between align-items-start">
          <div [ngClass]="{'text-muted text-decoration-line-through': isNoteDeleted(note)}">
            <small><strong>{{note.user?.first_name}} {{note.user?.name}}</strong>, {{note.created_at | date: 'dd.MM.yyyy, HH:mm'}}Uhr</small><br>{{note.description}}
          </div>
          <button *ngIf="!isNoteDeleted(note)" 
                  class="btn btn-sm ml-2" 
                  [ngClass]="isNoteWithin10Minutes(note) ? 'btn-danger' : 'btn-outline-danger'"
                  (click)="deleteNote(note.id, note)" 
                  [title]="isNoteWithin10Minutes(note) ? 'Endgültig löschen (innerhalb 10 Min)' : 'Als gelöscht markieren'">
            <i class="fa fa-trash"></i>
          </button>
          <small *ngIf="isNoteDeleted(note)" class="text-muted ml-2">Gelöscht</small>
        </div>
      </td>
    </tr>  

    </tbody>
  </table>
  </div>
